module.exports = ".btn:disabled{\r\n    opacity: 1;\r\n}"